import React, { useEffect } from "react";
import FormTicket from "./FormTicket";
import { useSite } from "../Provider";

const AddTicket = ({ ticket }) => {
  const { dispatch } = useSite();
  useEffect(() => {
    dispatch({ type: "set_div1", payload: [] });
    dispatch({ type: "set_div2", payload: [] });
    dispatch({ type: "set_div3", payload: [] });
    dispatch({ type: "set_div4", payload: [] });
  }, [dispatch]);

  return (
    <>
      <FormTicket
        ticket={ticket}
      />
    </>
  );
};

export default React.memo(AddTicket);
